import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from "react-router-dom";

function CheckToken(props) {

    const navigate = useNavigate();
    const [id] = useState(localStorage.getItem("id"));
    const [token] = useState(localStorage.getItem("token"));

    useEffect(() => {
        if (!id && !token)
            navigate("/login");
    }, [id, token, navigate]);

    return (
        <>
            {props.children || <Navigate to='/main' />}
        </>
    );

}


export default CheckToken;
